import { render } from "./AddBusinessUnits.vue?vue&type=template&id=13c3451f&ts=true"
import script from "./AddBusinessUnits.vue?vue&type=script&lang=ts"
export * from "./AddBusinessUnits.vue?vue&type=script&lang=ts"

import exportComponent from "/home/appstore/appstore/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__